import React, { useState } from "react";
import { Grid, Segment, Image, Message, Popup, List } from "semantic-ui-react";
import Wizard from "./importfiles/Wizard";
import FileSelection from "./importfiles/FileSelection";
import Download from "./importfiles/Download";
import image from "./images/logo.png";
import "./App.css";
import InputParams from "./importfiles/InputParams";

function App() {
  const [activeStep, setActiveStep] = useState(1);
  const [processedData, setProcessedData] = useState({
    cnSites: {},
    dnSites: {},
    nodes: {},
    links: {},
    meshLinks: {},
  });
  const [params, setParams] = useState();

  const nextStepHandler = (data, type) => {
    setActiveStep((prevState) => (prevState += 1));
    if (data != null && type === "filedata") {
      setProcessedData(data);
    } else if (data != null && type === "parameters") {
      setParams(data);
    }
  };

  const prevStepHandler = () => {
    setActiveStep((prevStep) => (prevStep -= 1));
  };
  return (
    <>
      <Segment.Group>
        <Segment style={{ backgroundColor: "#f5f5f5" }}>
          <Image src={image} size="small" verticalAlign="middle"></Image>
        </Segment>
        <Segment
          inverted
          style={{ backgroundColor: "#003A70", lineHeight: 0.6 }}
        >
          <span style={{ fontSize: "0.9rem", fontWeight: 700 }}>
            ANP Importer
          </span>
          <Popup
            trigger={
              <span
                style={{ fontSize: "0.9rem", fontWeight: 700, float: "right" }}
              >
                v1.0.4
              </span>
            }
          >
            <Popup.Header>Changelog</Popup.Header>
            <Popup.Content>
              <List bulleted>
                <List.Item>
                  <List.Content>v1.0.4</List.Content>
                  <List.List bulleted>
                    <List.Item>
                      <List.Content>
                        Fixed issue where the ANP output only contained data for
                        sector 1. This resulted in a LINKPlanner file that could
                        not be opened
                      </List.Content>
                    </List.Item>
                  </List.List>
                </List.Item>
                <List.Item>
                  <List.Content>v1.0.3</List.Content>
                  <List.List bulleted>
                    <List.Item>
                      <List.Content>
                        Reading the product family from the site file
                      </List.Content>
                    </List.Item>
                  </List.List>
                </List.Item>
                <List.Item>
                  <List.Content>v1.0.2</List.Content>
                  <List.List bulleted>
                    <List.Item>
                      <List.Content>
                        Fixed bug when there are no mesh links in the project
                      </List.Content>
                    </List.Item>
                  </List.List>
                </List.Item>
                <List.Item>
                  <List.Content>v1.0.1</List.Content>
                  <List.List bulleted>
                    <List.Item>
                      <List.Content>
                        Set the default Min IP Required for the mesh links based
                        on the highest "Data Flow" value in either direction
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content>
                        Display a summary showing the number of sites, DNs, CNs
                        and mesh links
                      </List.Content>
                    </List.Item>
                    <List.Item>
                      <List.Content>
                        Modify the SM Range rounding to ensure that all SMs are
                        within range in LINKPlanner
                      </List.Content>
                    </List.Item>
                  </List.List>
                </List.Item>
                <List.Item>
                  <List.Content>v1.0.0</List.Content>
                  <List.List bulleted>
                    <List.Item>
                      <List.Content>Initial release</List.Content>
                    </List.Item>
                  </List.List>
                </List.Item>
              </List>
            </Popup.Content>
          </Popup>
        </Segment>
      </Segment.Group>
      <Grid divided="vertically">
        <Grid.Row columns={3} style={{ height: "60vh" }}>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={12}>
            <Wizard step={activeStep}></Wizard>
            <FileSelection
              customClassName={activeStep === 1 ? "" : "no-display"}
              nextStepHandler={nextStepHandler}
            ></FileSelection>

            <InputParams
              customClassName={activeStep === 2 ? "" : "no-display"}
              nextStepHandler={nextStepHandler}
              prevStepHandler={prevStepHandler}
            ></InputParams>
            {activeStep === 3 ? (
              <Download
                data={processedData}
                params={params}
                prevStepHandler={prevStepHandler}
              ></Download>
            ) : null}
          </Grid.Column>
          <Grid.Column width={2}></Grid.Column>
        </Grid.Row>
      </Grid>
      <Message
        style={{
          width: "auto",
          position: "fixed",
          top: "89vh",
          right: "1vw",
        }}
        floating
      >
        Contact Us:{" "}
        <a
          href={`mailto:linkplanner@cambiumnetworks.com?subject=${encodeURIComponent(
            "ANP Importer"
          )}`}
        >
          linkplanner@cambiumnetworks.com{" "}
        </a>
      </Message>
    </>
  );
}

export default App;
